import { storeToRefs } from 'pinia';
import { useTenantStore } from './tenant';
import { useUserStore } from './user';
import { TEMPLATE_MAP } from '@star/template';
import { getSession, isH5, setLocalStorage, setSession } from '@star/utils';
import qs from 'qs';

export function useHot() {
  // @ts-ignore
  const local_theme = import.meta.env.VITE_THEME_NAME;
  const tenantStore = useTenantStore();

  const { tenantInfo, defaultArea, activeConfiguration, tResLoc, imgDomain } = storeToRefs(tenantStore);

  const userStore = useUserStore();
  const { isLogin, userInfo, isFreeUser, signInList, rechargeSuccess, withdrawSuccess } = storeToRefs(userStore);
  // 如果本地session存有主题名 则优先使用[方便测试环境切换主题] 前端本地主题名次之 再后端配置主题名
  let theme = getSession('themeName') || local_theme || tResLoc.value || '';
  // 根据url设置主题 优先级最高
  const qsObj = qs.parse(location.href.split('?')[1]) || {};
  if (qsObj.theme) {
    const _theme = qsObj.theme.split('#');
    setLocalStorage('theme', _theme[0]);
    setSession('themeName', _theme[0]);
    theme = _theme[0];
  }
  // theme = 'bigwin'
  let appTemplate = '';
  if (theme) {
    tResLoc.value = theme;
    const _key = theme + (isH5() ? 'App' : 'PC');
    appTemplate = TEMPLATE_MAP[_key] || TEMPLATE_MAP[theme];
  }

  let is_try = 0;
  if (theme.startsWith('SHIWAN_')) {
    is_try = 1;
  }
  return {
    hotData: {
      tenantInfo,
      isLogin,
      userInfo,
      isFreeUser,
      isLogined: isLogin,
    },
    is_try, // 是否是试玩
    rechargeSuccess, // ws返回的充值结果数据
    withdrawSuccess, // ws返回的提现结果数据
    setRechargeSuccessData: userStore.setRechargeSuccessData, // 设置ws充值数据方法 主要用于清空数据
    setWithdrawSuccessData: userStore.setWithdrawSuccessData, // 设置ws提现数据方法 主要用于清空数据
    signInList,
    defaultArea,
    activeConfiguration, // 代理盘控制
    tResLoc,
    imgDomain, // 图片域名地址
    appTemplate, // 使用的模板
  };
}
